import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function uiFilterReducer(state = initialState.savedFilters, action) {
	switch (action.type) {
		case types.GET_SAVED_FILTERS: {
			return action.response;
		}
		//TODO: PATCH call will return another object. Id needed to add a new state?
		case types.SAVE_FILTERS: {
			let originalState = _.cloneDeep(state);
			return [...originalState, action.response];
		}

		case types.UPDATE_FILTERS: {
			return action.response;
		}

		case types.DELETE_FILTERS: {
			let existingState = _.cloneDeep(state);
			return _.filter(existingState, (f) => f.uiFilterId != action.filterId);
		}

		default:
			return state;
	}
}
